import { render, staticRenderFns } from "./NotasFinalista-anterior.vue?vue&type=template&id=49157510&"
import script from "./NotasFinalista-anterior.vue?vue&type=script&lang=js&"
export * from "./NotasFinalista-anterior.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports